export default from './VideoPlayer'


// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js